import React from 'react'

const WebsiteIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      className={`transition-colors duration-200 ${className}`}
      {...props}
    >
      <path 
        d="M22 12C22 13.3133 21.7414 14.6137 21.2388 15.827C20.7362 17.0404 19.9996 18.1428 19.0709 19.0714C18.1423 20.0001 17.0399 20.7367 15.8265 21.2393C14.6132 21.7418 13.3128 22.0005 11.9995 22.0005C10.6862 22.0005 9.38581 21.7418 8.1725 21.2393C6.95918 20.7367 5.85673 20.0001 4.9281 19.0714C3.99947 18.1428 3.26284 17.0404 2.76027 15.827C2.25769 14.6137 1.99902 13.3133 1.99902 12C1.99902 9.34771 3.05264 6.80405 4.9281 4.92859C6.80356 3.05313 9.34723 1.99951 11.9995 1.99951C14.6518 1.99951 17.1955 3.05313 19.0709 4.92859C20.9464 6.80405 22 9.34771 22 12Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M16.0001 12C16.0001 13.313 15.8961 14.614 15.6951 15.827C15.4951 17.04 15.2001 18.142 14.8281 19.071C14.4571 20 14.0161 20.736 13.5311 21.239C13.0451 21.741 12.5251 22 12.0001 22C11.4751 22 10.9551 21.741 10.4701 21.239C9.98406 20.736 9.54305 19.999 9.17205 19.071C8.80005 18.142 8.50505 17.041 8.30405 15.827C8.09896 14.5617 7.99729 13.2818 8.00005 12C8.00005 10.687 8.10305 9.386 8.30405 8.173C8.50505 6.96 8.80005 5.858 9.17205 4.929C9.54305 4 9.98405 3.264 10.4691 2.761C10.9551 2.26 11.4751 2 12.0001 2C12.5251 2 13.0451 2.259 13.5301 2.761C14.0161 3.264 14.4571 4.001 14.8281 4.929C15.2001 5.858 15.4951 6.959 15.6951 8.173C15.8971 9.386 16.0001 10.687 16.0001 12Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M2 12H22" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  )
}

export default WebsiteIcon
